var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    opacity: 0.3,
    fillRule: "evenodd",
    d: "M15.5,10.348l-.581,3.487,0,.012a.833.833,0,0,1-.969.671L4.472,12.8a.833.833,0,0,1-.652-.591L2.3,6.883a.833.833,0,0,1,.8-1.062H14.539l.511-2.19a.983.983,0,0,1,.957-.76h1.721a.983.983,0,0,1,0,1.967h-.941Z",
    transform: "translate(-0.378 -0.478)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M6.25,20.5A1.25,1.25,0,1,1,7.5,19.25,1.25,1.25,0,0,1,6.25,20.5Zm7.5,0A1.25,1.25,0,1,1,15,19.25,1.25,1.25,0,0,1,13.75,20.5Z",
    transform: "translate(-0.833 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.55274690da431706d952c845792c425a.svg";
export { ForwardRef as ReactComponent };